<template>
  <div>
    <div class="tab-swiper-div">
      <swiper
        ref="tabMenuSwiper"
        class="tab-swiper"
        :options="tabSwiperOption"
      >
        <!-- 탭 리스트 반복 렌더링, 현재 라우트와 일치하는 탭에 active 클래스 적용 -->
        <swiper-slide
          v-for="(tab, index) in tabList"
          :key="index"
          class="slide"
          :class="{ active: tab.name === routeName }"
        >
          <router-link :to="{ name: tab.name }">
            {{ tab.title }}
          </router-link>
        </swiper-slide>

        <!-- 이전 버튼, tabActive 상태에 따라 숨김 표시 -->
        <div
          class="swiper-button-prev"
          :class="{ none: btnPrevType }"
          @click="btnPrev"
          slot="button-prev"
        >
          <img src="@/assets/img/icon/icon_scroll_left.png" alt="prev" />
        </div>

        <!-- 다음 버튼, tabActive 상태에 따라 숨김 표시 -->
        <div
          class="swiper-button-next"
          :class="{ none: btnNextType }"
          @click="btnNext"
          slot="button-next"
        >
          <img src="@/assets/img/icon/icon_scroll_right.png" alt="next" />
        </div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'TabDepthMenu',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    tabList: {
      type: Array,
      default: () => [], // 탭 메뉴 목록
    },
    slidesPerView: {
      type: Number,
      default: 3.64, // 한 화면에 보이는 탭 개수 비율
    },
  },
  data() {
    return {
      tabActive: null, // 현재 활성 탭 인덱스
      tabSwiperOption: {
        slideToClickedSlide: true, // 클릭 시 슬라이드 이동 활성화
        slidesPerView: this.slidesPerView,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      btnPrevType: true,  // 이전 버튼 숨김 여부(true면 숨김)
      btnNextType: false, // 다음 버튼 숨김 여부
    };
  },
  computed: {
    // 현재 라우트 이름에 따라 active 탭 결정, 특정 라우트는 'littleDragons' 탭으로 강제 매칭
    routeName() {
      if (
        this.$route.name === 'programGuide' ||
        this.$route.name === 'trainingTimetable' ||
        this.$route.name === 'joinClub'
      ) {
        return 'littleDragons';
      } else {
        // 탭 목록을 순회하며 현재 라우트와 이름이 같은 탭을 찾아 활성화 처리 및 버튼 상태 갱신
        Object.entries(this.tabList).forEach(([index, value]) => {
          if (value.name === this.$route.name) {
            this.tabActive = Number(index);
            this.btnDisplay();
          }
        });
        return this.$route.name;
      }
    },
  },
  watch: {
    // routeName 변경 시 슬라이드 위치 이동
    routeName: {
      handler() {
        this.slideToMove();
      },
    },
  },
  mounted() {
    this.slideToMove(); // 초기 마운트 시 활성 탭 위치로 슬라이드 이동
  },
  methods: {
    // 활성 탭 위치로 슬라이드 이동
    slideToMove() {
      this.$refs.tabMenuSwiper.swiperInstance.slideTo(this.tabActive, 0);
    },
    // 현재 활성 탭에 따라 이전/다음 버튼 표시 상태 갱신
    btnDisplay() {
      this.btnPrevType = this.tabActive === 0; // 첫 탭이면 이전 버튼 숨김
      this.btnNextType = this.tabActive === this.tabList.length - 1; // 마지막 탭이면 다음 버튼 숨김
      if (this.tabActive > 0) {
        this.btnPrevType = false;
      }
      if (this.tabActive < this.tabList.length - 1) {
        this.btnNextType = false;
      }
    },
    // 이전 버튼 클릭 시 활성 탭 인덱스 감소 및 라우트 이동
    btnPrev() {
      if (this.tabActive > 0) {
        this.tabActive -= 1;
        this.$router.push({
          name: this.tabList[this.tabActive].name,
        });
      }
    },
    // 다음 버튼 클릭 시 활성 탭 인덱스 증가 및 라우트 이동
    btnNext() {
      if (this.tabActive < this.tabList.length - 1) {
        this.tabActive += 1;
        this.$router.push({
          name: this.tabList[this.tabActive].name,
        });
      }
    },
  },
};
</script>
